"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M18.74 5.272H6.753c0-.703.564-1.272 1.26-1.272H18.74c.696 0 1.26.57 1.26 1.272v10.824c0 .703-.564 1.272-1.26 1.272V5.272z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.35 6.626h10.554c.745 0 1.349.61 1.349 1.362v10.65c0 .752-.604 1.362-1.35 1.362H5.35C4.604 20 4 19.39 4 18.638V7.988c0-.752.604-1.362 1.35-1.362zm2.72 8.248l-2.8 3.566h10.723l-4.08-5.197-2.562 3.262-1.281-1.631z" })), "Gallery");
//# sourceMappingURL=Gallery.js.map